function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Input } from 'antd';
import omit from 'omit.js';
import classNames from 'classnames';
import formMethods from "../utils/form-methods";
import { staticFormatMessage as formatMessage } from "../locale";
import "./style/index";
import { jsx as _jsx } from "react/jsx-runtime";
var InputId = function InputId(props) {
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, omit(props, formMethods)), {}, {
    type: "number",
    className: classNames('igloo-input', props.className)
  }));
};
InputId.formItemPropsHandler = function (config) {
  var length = config.length,
    maxLength = config.maxLength,
    minLength = config.minLength,
    label = config.label,
    idType = config.idType;
  var rules = [];
  if (length !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length === length) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {length} digits.',
          values: {
            length: length,
            label: label
          }
        }));
      }
    });
  }
  if (maxLength !== undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length >= minLength && String(value).length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {minLength} - {maxLength} digits.',
          values: {
            maxLength: maxLength,
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }
  if (maxLength !== undefined && minLength === undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be less than {maxLength} digits.',
          values: {
            maxLength: maxLength,
            label: label
          }
        }));
      }
    });
  }
  if (maxLength === undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length >= minLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be at least {minLength} digits.',
          values: {
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }
  if (idType === 'KTP') {
    rules.push({
      validator: function validator(rule, value) {
        if (!/^((1[1-9])|(21)|([37][1-6])|(5[1-4])|(6[1-5])|([8-9][1-2]))[0-9]{4}(([0-6][0-9])|(7[0-1]))((0[1-9])|(1[0-2]))[0-9]{6}$/.test(value)) {
          return Promise.reject(formatMessage({
            id: 'Invalid KTP Number.'
          }));
        }
        return Promise.resolve();
      }
    });
  }
  if (idType === 'NIK') {
    rules.push({
      validator: function validator(rule, value) {
        if (!/^((1[1-9])|(21)|([37][1-6])|(5[1-4])|(6[1-5])|([8-9][1-2]))[0-9]{4}(([0-6][0-9])|(7[0-1]))((0[1-9])|(1[0-2]))[0-9]{6}$/.test(value)) {
          return Promise.reject(formatMessage({
            id: 'Invalid NIK Number.'
          }));
        }
        return Promise.resolve();
      }
    });
  }
  return {
    rules: rules
  };
};
export default InputId;